import * as React from 'react';
export const rupaySvg = React.forwardRef(function rupaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1B3281',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.533 13.297 29 16l-3.084 2.707 1.617-5.411Z',
      fill: '#098B45',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.517 13.297 27.982 16 24.9 18.708l1.617-5.411Z',
      fill: '#EF7922',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.383 14.933h.712c.25 0 .434-.033.547-.1.115-.07.2-.186.25-.355.05-.171.038-.291-.036-.359-.074-.069-.25-.103-.527-.103h-.671l-.275.917ZM3 17.723l1.463-4.893H6.8c.73 0 1.22.107 1.467.329.246.22.295.577.146 1.082-.09.296-.227.545-.414.743a1.936 1.936 0 0 1-.734.468c.256.057.42.171.492.341.073.17.065.42-.023.745l-.179.684v.019c-.052.191-.036.294.047.302l-.054.18H5.967c.006-.114.015-.218.026-.304.012-.089.026-.157.04-.204l.147-.489c.074-.254.079-.431.01-.533-.07-.106-.226-.157-.47-.157h-.666l-.507 1.687H3Zm9.754-3.611-1.078 3.611h-1.31l.16-.529c-.23.21-.465.37-.704.472a1.824 1.824 0 0 1-.746.156c-.217 0-.403-.037-.553-.11a.73.73 0 0 1-.34-.326.875.875 0 0 1-.085-.47c.011-.185.081-.495.211-.93l.56-1.874H10.3l-.557 1.865c-.082.273-.101.465-.061.57.041.105.151.16.331.16.18 0 .332-.061.458-.185.127-.123.225-.306.299-.55l.553-1.86h1.431Zm1.851.918h.506c.327 0 .556-.037.69-.11.13-.073.223-.203.28-.388.056-.188.041-.319-.044-.392-.082-.073-.292-.11-.628-.11h-.504l-.3 1Zm-2.37 2.693 1.46-4.893h2.01c.444 0 .787.024 1.032.078.244.051.435.134.577.251a.981.981 0 0 1 .333.57c.043.227.017.492-.075.803-.164.547-.45.966-.86 1.26-.41.288-.918.434-1.522.434h-.941l-.447 1.497h-1.568Zm7.371-1.613a5.54 5.54 0 0 1-.596.172c-.386.096-.603.224-.65.383-.033.102-.02.181.035.24.053.057.144.086.274.086.238 0 .429-.055.572-.166.142-.112.25-.287.324-.529l.031-.116.01-.07Zm-.348 1.613.015-.342a2.68 2.68 0 0 1-.7.357 2.377 2.377 0 0 1-.751.117c-.406 0-.69-.103-.852-.301-.163-.199-.189-.484-.079-.848.106-.359.294-.624.565-.793.268-.17.719-.293 1.35-.371.08-.012.187-.022.322-.037.466-.05.729-.166.784-.354.03-.103.012-.18-.057-.226-.067-.049-.192-.072-.37-.072a.69.69 0 0 0-.368.089.543.543 0 0 0-.221.272h-1.397a1.52 1.52 0 0 1 .771-.92c.385-.208.894-.308 1.524-.308.296 0 .561.025.795.081.235.054.407.13.518.223a.642.642 0 0 1 .241.391c.027.145-.003.352-.084.624l-.601 2.012a.376.376 0 0 0-.013.179.214.214 0 0 0 .08.126l-.034.102h-1.44.002Zm1.449 1.423.318-1.068h.41a.626.626 0 0 0 .321-.072.378.378 0 0 0 .16-.235.79.79 0 0 0 .032-.155 1.75 1.75 0 0 0 0-.197l-.22-3.307h1.451l-.022 2.192 1.267-2.192h1.348l-2.239 3.593a12.18 12.18 0 0 1-.556.829 1.768 1.768 0 0 1-.331.342 1.272 1.272 0 0 1-.459.23c-.167.045-.421.068-.762.068a10.638 10.638 0 0 1-.717-.029',
      fill: '#fff',
    }),
  );
});
rupaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var rupay = {
  category: 'brand',
  colorable: false,
  name: 'rupay',
  svg: rupaySvg,
};
